module.exports = __webpack_public_path__ + "1e8c3e2e6e5437af5cf255d8022f7aad.svg";